
import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import './App.css';

const PASSWORD = 'china2025'; // Change this to your hardcoded word
const START_DATE = new Date('2025-08-02');
const END_DATE = new Date('2025-08-13');
const IMAGE_COUNT = 12;

function getDayIndex() {
  const today = new Date();
  if (today < START_DATE) return 0;
  // Calculate days since START_DATE
  const diff = Math.floor((today - START_DATE) / (1000 * 60 * 60 * 24));
  if (diff < 0 || diff >= IMAGE_COUNT) return IMAGE_COUNT - 1;
  return diff;
}

function getImageFile(dayIdx) {
  const ext = [4, 6, 12].includes(dayIdx + 1) ? 'jpg' : 'JPG';
  return `/images/${dayIdx + 1}.${ext}`;
}

function getMarkdownFile(dayIdx) {
  return `/md/${dayIdx + 1}.md`;
}

function App() {
  const [input, setInput] = useState('');
  const [loginError, setLoginError] = useState('');
  const [loggedIn, setLoggedIn] = useState(false);
  const [flipped, setFlipped] = useState(false);
  const [mdContent, setMdContent] = useState('');
  const [passwords, setPasswords] = useState([]);
  const [loadingPwd, setLoadingPwd] = useState(true);
  const [manualDayIdx, setManualDayIdx] = useState(null);
  const [masterMode, setMasterMode] = useState(false);
  const dayIdx = manualDayIdx !== null ? manualDayIdx : getDayIndex();
  const today = new Date();
  const isValidDate = today.getTime() >= START_DATE.getTime() && today.getTime() <= END_DATE.getTime();

  const [showButtons, setShowButtons] = useState(false);

  useEffect(() => {
    fetch('/pwd.txt')
      .then(res => res.text())
      .then(text => {
        setPasswords(text.split('\n').map(p => p.trim()));
        setLoadingPwd(false);
      });
  }, []);
  useEffect(() => {
    if (flipped) {
      fetch(getMarkdownFile(dayIdx))
        .then(res => res.text())
        .then(setMdContent);
    }
  }, [flipped, dayIdx]);

  const handleLogin = (e) => {
    e.preventDefault();
    const inputVal = input.trim();
    setLoginError('');
    if (!loadingPwd && inputVal.toLowerCase() === PASSWORD.toLowerCase()) {
      setLoggedIn(true);
      setMasterMode(true);
      setManualDayIdx(getDayIndex());
      setShowButtons(false);
      return;
    }
    if (!loadingPwd && passwords[getDayIndex()] && inputVal.toLowerCase() === passwords[getDayIndex()].toLowerCase()) {
      setLoggedIn(true);
      setMasterMode(true);
      setManualDayIdx(null);
      setShowButtons(false);
      return;
    }
    setLoginError('Wachtwoord is niet correct. Probeer opnieuw.');
  };

  return (
    <div className="App">
      {!loggedIn ? (
        <form className="login-form" onSubmit={handleLogin}>
          <h2>Vul het juiste wachtwoord in dat je vandaag van Jordanneke hebt gekregen</h2>
          <input
            type="password"
            value={input}
            onChange={e => setInput(e.target.value)}
            placeholder="Wachtwoord..."
            disabled={loadingPwd}
          />
          <button type="submit" disabled={loadingPwd}>Submit</button> 
          {loadingPwd && <div style={{marginTop: '1rem'}}>Wachtwoord wordt geladen...</div>}
          {loginError && <div style={{color: 'red', marginTop: '1rem'}}>{loginError}</div>}
        </form>
      ) : (masterMode || isValidDate) ? (
        <div className="card-container">
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
            <div className={`card${flipped ? ' flipped' : ''}`} onClick={() => setFlipped(f => !f)}>
              <div className="card-face card-front">
                <img src={getImageFile(dayIdx)} alt={`Day ${dayIdx + 1}`} className="day-image" />
                <div className="card-label">Flip</div>
              </div>
              <div className="card-face card-back">
                <div className="markdown-content">
                  <ReactMarkdown>{mdContent}</ReactMarkdown>
                </div>
                <div className="card-label">Flip</div>
              </div>
            </div>
            {masterMode && (
              <div className="nav-buttons">
                <p>{showButtons}</p>
                <button
                  className="nav-btn"
                  onClick={() => null}
                  disabled={showButtons}
                >Vorige</button>
                <button
                  className="nav-btn"
                  onClick={() => null}
                 disabled={showButtons}
                >Volgende</button>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="empty-state">
          <h2>Jordan created something great</h2>
        </div>
      )}
    </div>
  );
}

export default App;
